(() => {
  if (!document.querySelector('[data-orelvon-home-search]')) return;

  document.body.classList.add('orelvon-home-protected');

  const main = document.querySelector('main, #MainContent');
  if (!main) return;

  const isEditable = (target) =>
    target instanceof Element &&
    Boolean(target.closest('input, textarea, select, [contenteditable="true"]'));

  main.addEventListener(
    'contextmenu',
    (event) => {
      if (!isEditable(event.target)) event.preventDefault();
    },
    { capture: true }
  );

  main.addEventListener(
    'dragstart',
    (event) => {
      if (event.target instanceof Element && event.target.closest('img, picture')) {
        event.preventDefault();
      }
    },
    { capture: true }
  );

  main.addEventListener(
    'copy',
    (event) => {
      if (isEditable(event.target)) return;
      const selection = window.getSelection();
      if (selection && !selection.isCollapsed) event.preventDefault();
    },
    { capture: true }
  );
})();

